import React, { ReactNode } from 'react';

import { Subtitle, Title, TwoRowTextWrapper } from './index.styled';

export const TwoRowText = ({
  title,
  subtitle,
  margin,
  titleColor,
  color,
  fontWeight,
  fontSize,
  boldTitle,
  titleTooltipDataFor,
  titleTooltipDataTip,
  subtitleTooltipDataFor,
  subtitleTooltipDataTip,
  display,
  titleOnClick,
  subtitleOnClick,
  cursor,
  titleDecoration,
  titleFontFamily,
}: {
  title?: string | ReactNode;
  subtitle?: string | ReactNode;
  margin?: string;
  titleColor?: string;
  color?: string;
  fontWeight?: string;
  fontSize?: string;
  boldTitle?: boolean;
  titleTooltipDataFor?: string;
  titleTooltipDataTip?: string | null;
  subtitleTooltipDataFor?: string;
  subtitleTooltipDataTip?: string | null;
  display?: string;
  titleOnClick?: () => void;
  subtitleOnClick?: () => void;
  cursor?: string;
  titleDecoration?: string;
  titleFontFamily?: string;
}) => {
  return (
    <TwoRowTextWrapper margin={margin} display={display}>
      {title && (
        <Title
          titleColor={titleColor}
          data-for={titleTooltipDataFor}
          data-tip={titleTooltipDataTip}
          bold={boldTitle}
          onClick={titleOnClick}
          cursor={cursor}
          textDecoration={titleDecoration}
          titleFontFamily={titleFontFamily}
        >
          {title}
        </Title>
      )}
      {subtitle && (
        <Subtitle
          data-for={subtitleTooltipDataFor}
          data-tip={subtitleTooltipDataTip}
          color={color}
          fontWeight={fontWeight}
          fontSize={fontSize}
          onClick={subtitleOnClick}
        >
          {subtitle}
        </Subtitle>
      )}
    </TwoRowTextWrapper>
  );
};
